var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider-container"},[_c('div',{staticClass:"border",style:(_vm.borderStyle)}),_c('div',{staticClass:"title",style:(_vm.titleStyle)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_c('div',{staticClass:"border",style:(_vm.borderStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }